<template>
    <div class="location">
        <img class="building-icon"  :src="[ redIconPosition <= 15 ? 'http://www.artgogo.com/online-exhibition/amicitia/original-img/first-floor.png' : 'http://www.artgogo.com/online-exhibition/amicitia/original-img/second-floor.png']"  alt="">
        <div class="red-icon" :class="'pos'+redIconPosition">
            <img src="../assets/img/location.png" alt="">
        </div>
        
    </div>
</template>
<style>
.location{
    width: 0.875rem;
    height: 0.65rem;
    background:rgba(000, 000, 000, 0.3);
    position:absolute;
    left: -0.09rem;
    bottom: 0.05rem;
    border-radius:4px;
}
.location:after{
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    left: 0.05rem;
    top: 100%;
    border: 0.04rem solid transparent;
    border-top-color: rgba(000, 000, 000, 0.3);
}


.location .building-icon{
    margin: 0.07rem 0 0 0.17rem;
    width: 60%;
    height: auto;
}
.red-icon{
    position: absolute;
    width:0.05rem;
    left: 45%;
    bottom: 28%;
}
.red-icon img {
    width:0.04rem;
}
.pos3{
    left: 26%;
    bottom: 4%;
} 
.pos4{
    bottom: 23%;
    left: 38%;
} 
.pos5{
    left: 45%;
    bottom: 37%;

} 
.pos6{
    left: 52%;
    bottom: 51%;

} 
.pos7{
    left: 52%;
    bottom: 40%;
}  
.pos8{
    left: 67%;
    bottom: 28%;
} 
.pos9{
    left: 67%;
    bottom: 28%;
} 
.pos10{
    left: 67%;
    bottom: 28%;
} 
.pos11{
    left: 32%;
    bottom: 51%;
} 
.pos12{
    left: 46%;
    bottom: 67%;
} 
.pos13{
    left: 70%;
    bottom: 66%;
}  
.pos14{
    left: 54%;
    bottom: 63%;
}
.pos15{
    left: 58%;
    bottom: 23%;
}

.pos17{
    left: 52%;
    bottom: 51%;
}
.pos18{
    left: 64%;
    bottom: 53%;
}
.pos19{
    left: 64%;
    bottom: 42%;
}
.pos20{
    left: 47%;
    bottom: 24%;
}
.pos21{
    left: 34%;
    bottom: 4%;
}
.pos23{
    left: 31%;
    bottom: 53%;
}
.pos24{
    left: 43%;
    bottom: 74%;
}
.pos25{
    left: 37%;
    bottom: 68%;
}
.pos26{
    left: 57%;
    bottom: 67%;
}
.pos27{
    left: 57%;
    bottom: 67%;
}
.pos28{
    left: 60%;
    bottom: 64%;
}



</style>
<script>

export default {
    components: {
        
    },

    props:[
        'redIconPos'
    ],
    data(){
        return{
            redIconPosition: this.redIconPos-1
        }
    },
}
</script>
